import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { ariaDescribedByIds, descriptionId, getTemplate, labelValue, schemaRequiresTrueValue } from '@rjsf/utils';
/** The `CheckBoxWidget` is a widget for rendering boolean properties.
 *  It is typically used to represent a boolean.
 *
 * @param props - The `WidgetProps` for this component
 */

function CheckboxWidget(_ref) {
  var schema = _ref.schema,
      uiSchema = _ref.uiSchema,
      options = _ref.options,
      id = _ref.id,
      value = _ref.value,
      disabled = _ref.disabled,
      readonly = _ref.readonly,
      label = _ref.label,
      hideLabel = _ref.hideLabel,
      _ref$autofocus = _ref.autofocus,
      autofocus = _ref$autofocus === void 0 ? false : _ref$autofocus,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onChange = _ref.onChange,
      registry = _ref.registry;

  var _a;

  var DescriptionFieldTemplate = getTemplate('DescriptionFieldTemplate', registry, options); // Because an unchecked checkbox will cause html5 validation to fail, only add
  // the "required" attribute if the field value must be "true", due to the
  // "const" or "enum" keywords

  var required = schemaRequiresTrueValue(schema);
  var handleChange = useCallback(function (event) {
    return onChange(event.target.checked);
  }, [onChange]);
  var handleBlur = useCallback(function (event) {
    return onBlur(id, event.target.checked);
  }, [onBlur, id]);
  var handleFocus = useCallback(function (event) {
    return onFocus(id, event.target.checked);
  }, [onFocus, id]);
  var description = (_a = options.description) !== null && _a !== void 0 ? _a : schema.description;
  return _jsxs("div", {
    className: "checkbox ".concat(disabled || readonly ? 'disabled' : ''),
    children: [!hideLabel && !!description && _jsx(DescriptionFieldTemplate, {
      id: descriptionId(id),
      description: description,
      schema: schema,
      uiSchema: uiSchema,
      registry: registry
    }), _jsxs("label", {
      children: [_jsx("input", {
        type: 'checkbox',
        id: id,
        name: id,
        checked: typeof value === 'undefined' ? false : value,
        required: required,
        disabled: disabled || readonly,
        autoFocus: autofocus,
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: handleFocus,
        "aria-describedby": ariaDescribedByIds(id)
      }), labelValue(_jsx("span", {
        children: label
      }), hideLabel)]
    })]
  });
}

export default CheckboxWidget;